<banner-app
  [Fixtop]="''"
  [retroSelected]="true"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>
<div class="final-page__container">
  <div class="final-page__text-container">
    <p class="final-page__text-title">¡Verifica la información!</p>
    <p class="final-page__text-subtitle">
      Hemos notado que algunos de los datos que proporcionaste podrían no estar
      correctos.
    </p>
    <p class="final-page__text">
      Revisa la información y asegúrate de que todo esté bien para que podamos
      avanzar con tu cotización.
    </p>
  </div>
  <div class="final-page__image-container">
    <img
      src="./assets/img/check-the-information.png"
      class="final-page__image"
      alt="Imagen de no pasa SARLAFT"
      loading="lazy"
    />
  </div>
  <div class="final-page__button-container">
    <button class="final-page__button" (click)="retry()">Entendido</button>
  </div>
</div>

<app-footer-app class="footer-fixed" />
